import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import ProductcategoryDashboard from '../ProductcategoryDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function ProductcategoryPage() {
    const dispatch = useDispatch();
    const { ProductcategoryList} = useSelector((state)=>state.dmpaslice)
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < ProductcategoryDashboard />
    )

}